<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import { Helper } from "@/mixin/helper";

export default {
  page: {
    title: "Penjadwalan Laporan",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  mixins: [Helper],
  data() {
    return {
      phaseOneShow: false,
      selected: {
        masterScheduler: [],
      },
      selectedModel: {
        masterScheduler: [],
      },
      allSelected: {
        masterScheduler: false,
      },
      indeterminate: {
        masterScheduler: true,
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      filteredItems: [],
      scheduler: {
        scheduler: [
          {
            schedulerId: 1,
            reportName: "Peringatan",
            totalEmail: 8,
            period: "Harian",
            emailReceiver:
              "riswanto@mceasy.cloud; alfian_yudistira@mceasy.cloud; elena_gun@mceasy.cloud; mustain_putra@mceasy.cloud; bimo_sebastian@mceasy.cloud; abi@mceasy.cloud; dikaseptian@mceasy.cloud; eman@mceasy.cloud;",
          },
          {
            schedulerId: 2,
            reportName: "Geolokasi",
            totalEmail: 6,
            period: "Mingguan",
            emailReceiver:
              "riswanto@mceasy.cloud; alfian_yudistira@mceasy.cloud; bimo_sebastian@mceasy.cloud; abi@mceasy.cloud; dikaseptian@mceasy.cloud; eman@mceasy.cloud;",
          },
          {
            schedulerId: 3,
            reportName: "Pintu",
            totalEmail: 8,
            period: "Bulanan",
            emailReceiver:
              "riswanto@mceasy.cloud; alfian_yudistira@mceasy.cloud; elena_gun@mceasy.cloud; mustain_putra@mceasy.cloud; bimo_sebastian@mceasy.cloud; abi@mceasy.cloud; dikaseptian@mceasy.cloud; eman@mceasy.cloud;",
          },
        ],
      },
      fields: [
        {
          key: "check",
          thClass: "mc-table--30",
          sortable: false,
        },
        {
          key: "showDetail",
          thClass: "mc-table--30",
          label: "",
          sortable: false,
        },
        {
          key: "reportName",
          label: "Nama Laporan",
          sortable: true,
        },
        {
          key: "totalEmail",
          label: "Jumlah Penerima Email",
          sortable: true,
        },
        {
          key: "period",
          label: "Periode Pengiriman",
          sortable: true,
        },
      ],
    };
  },
  computed: {
    title() {
      // return this.$t("setting.list.userSetting.pengaturanPengguna");
      return "Penjadwalan Laporan";
    },

    rows() {
      return this.scheduler.scheduler.length;
    },

    totalTrue() {
      return this.selectedModel.masterScheduler.filter((c) => c === true);
    },
  },
  mounted() {
    this.totalRows = this.scheduler.scheduler.length;
  },
  created() {
    for (let i = 0; i < this.scheduler.scheduler.length; i++) {
      this.selectedModel.masterScheduler.push(false);
    }

    this.$watch("selected.masterScheduler", (newValue) => {
      if (newValue.length === 0) {
        this.indeterminate.masterScheduler = false;
        this.allSelected.masterScheduler = false;
      } else if (newValue.length == this.scheduler.scheduler.length) {
        this.indeterminate.masterScheduler = false;
        this.allSelected.masterScheduler = true;
      } else {
        this.indeterminate.masterScheduler = true;
        this.allSelected.masterScheduler = false;
      }
    });
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    toggleAll(checked, param) {
      this.selectedModel[param] = [];
      this.selected[param] = [];
      if (checked) {
        for (let i = 0; i < this.scheduler.scheduler.length; i++) {
          this.selected[param].push(this.scheduler.scheduler[i]);
          this.selectedModel[param][
            this.scheduler.scheduler[i].schedulerId
          ] = true;
        }
        this.allSelected[param] = true;
      } else {
        for (let i = 0; i < this.scheduler.scheduler.length; i++) {
          this.selectedModel[param].push(false);
          this.selectedModel[param][
            this.scheduler.scheduler[i].schedulerId
          ] = false;
        }
        this.selected[param] = [];
        this.allSelected[param] = false;
      }
    },
    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data.item);
      } else {
        var myIndex = this.selected[param].indexOf(data.item);
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1);
        }
      }

      if (this.selected.length == this.scheduler.scheduler.length) {
        this.allSelected.masterScheduler = true;
      } else {
        this.allSelected.masterScheduler = false;
      }
    },
    clearDelete() {
      this.allSelected.masterScheduler = false;
      this.selectedModel.masterScheduler.forEach((element, index) => {
        this.selectedModel.masterScheduler[index] = false;
      });
      this.selected.masterScheduler.splice(
        0,
        this.selected.masterScheduler.length
      );
    },
  },
};
</script>
<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />
      <p class="mb-4">Mengatur seberapa sering penjadwalan laporan dikirim.</p>
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button  @click="$router.push({ name: 'Report Scheduler History' })" variant="outline-primary" class="ms-3">
            <i class="mc-fa icon-outline_file-text"></i>
            Riwayat Pengiriman Email
          </b-button>
          <b-button
            @click="$router.push({ name: 'Report' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t("global.back") }}
          </b-button>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="mc-table-filter text-end">
            <b-button
              variant="primary"
              @click="$router.push({ name: 'Report Scheduler Create' })"
            >
              <i class="mc-fa icon-outline_plus"></i>
              Penjadwalan Baru
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
            <h6 v-if="totalTrue.length" class="mc-row-check">
              <span class="badge btn-success">{{ totalTrue.length }}</span>
              Baris terpilih.
              <a class="color-primary" @click="clearDelete">Bersihkan semua</a>
            </h6>
          </div>

          <div
            class="col-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper"
          >
            <div class="mc-table-view">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-end"
              >
                <label
                  class="d-inline-flex align-items-center mc-table-view__search"
                >
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            sort-by="fullname"
            :fields="fields"
            :items="scheduler.scheduler"
            class="datatables mc-table-collapse"
            responsive="md"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #head(check)>
              <div class="form-check">
                <b-form-checkbox
                  @change="toggleAll($event, 'masterScheduler')"
                  v-model="allSelected.masterScheduler"
                  :indeterminate="indeterminate.masterScheduler"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <b-form-checkbox
                  @change="checkTable($event, data, 'masterScheduler')"
                  v-model="selectedModel.masterScheduler[data.item.schedulerId]"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(showDetail)="row">
              <a size="sm" @click="row.toggleDetails" class="mr-2">
                <i
                  :class="
                    row.detailsShowing
                      ? 'mc-fa icon-outline_chevron-up'
                      : 'mc-fa icon-outline_chevron-down'
                  "
                ></i>
              </a>
            </template>

            <template #cell(reportName)="data">
              <strong class="text-primary">
                {{ data.item.reportName }}
              </strong>
            </template>

            <template #row-details="row">
              <div class="ps-2">
                <h6><strong>Penerima Email</strong></h6>
                <p class="fs-6">{{ row.item.emailReceiver }}</p>
              </div>
            </template>

            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Menampilkan
                <b-form-select
                  class="form-select form-select-sm"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                >
                </b-form-select>
                entri.
                <p>
                  Menampilkan&nbsp;<strong>{{
                    filteredItems.length > 0
                      ? (currentPage - 1) * perPage + 1
                      : 0
                  }}</strong
                  >&nbsp;sampai&nbsp;<strong>{{
                    Math.min(filteredItems.length, currentPage * perPage)
                  }}</strong
                  >&nbsp;dari&nbsp;<strong>{{ filteredItems.length }}</strong
                  >&nbsp;entri.
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
